import api from "../../config/axiosConfig";

import { IAuthenticate } from "../../interfaces/IAuthenticate";

const Authenticate = async (data: IAuthenticate) => {
   return await api.post("/User", data);
};

export default Authenticate;
